import { germplasmGetAllForDropdown } from "@/api/germplasm";

const state = {
    germplasmOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.germplasmOptions = data;
    },
};

const actions = {
    async germplasmGetAllForDropdown({ commit }) {
        let res = await germplasmGetAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/germplasm.js